import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getCateListAction, resetCateErrorAction, setCurFirstCateId } from '../../modules/common/cateModule';
import { useState } from 'react';
import CateIconBtn from '../common/button/CateIconBtn';
import { Link } from 'react-router-dom';
import {isMobileOnly} from 'react-device-detect';
import { useHistory } from 'react-router-dom';

const HpCateItemsBlock = styled.div`
    padding: ${isMobileOnly?"40px 0":"130px 0 145px"};
    //padding: ${isMobileOnly?"8vw 0 8vw 0":"130px 0 145px"};   
    max-width: 1176px;
    margin: 0 auto;
    // ${isMobileOnly&&`
    //     margin-bottom: 25vw;
    //     border-top:1px solid #ccc;
    //     border-bottom:1px solid #ccc;
    // `}
`;

const TempMobileSplitter = styled.div`
  /*mobile 공간투어 나올때까지 임시로 구분라인*/
    position:absolute;
    top:-8vw;
    left:10vw;
    width:90vw;
    height:1px;
    border: 1px solid #ccc;
`;

const HpCateItemsUlBlock = styled.ul`
    width: 100%;    
    ${isMobileOnly?`
        overflow: auto;
        white-space: nowrap;
        padding: 10px 0;
        a {
            li { display: inline-block; clear: both; }                                 
            margin-right: 20px; 
            &:last-of-type {margin-right:4vw;}
            &:first-of-type {margin-left:4vw;}        
        }

    `:`    
     max-width: 1176px;
     // margin: 0 auto;    
     // display:grid;
     // grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
     // grid-gap: 0.1rem;
     // grid-auto-flow: dense;
     display: flex;
     justify-content: space-between;
    `}
`;


const HpCateItems = () => {

    const dispatch = useDispatch();
    const history = useHistory();

    const { categoryItems, error, loading, curMenu } = useSelector(
        ({ cateItemsReducer, loadingReducer, headerReducer }) => ({
            categoryItems: cateItemsReducer.cateItems,
            error: cateItemsReducer.error,
            loading: loadingReducer['es/LIST_CATE'],
            curMenu: headerReducer.curMenu
        })
    );

    // console.log("loading : " + loading + ", error : " + error + ",  list : " + JSON.stringify(categoryItems));
    useEffect(() => {

        if (categoryItems === null) {
            dispatch(getCateListAction());
        } else {
            dispatch(setCurFirstCateId(categoryItems[0].id));
        }

    }, [categoryItems]);

    if (error !== null && error !== undefined && categoryItems === null) {
        dispatch(resetCateErrorAction());
        return <HpCateItemsBlock> 오류 발생 !</HpCateItemsBlock>
    }

    if (loading !== null && loading !== undefined) {
        return <HpCateItemsBlock></HpCateItemsBlock>;
    }

    if (categoryItems === null || categoryItems.length === 0) {
        return <HpCateItemsBlock></HpCateItemsBlock>;
    }

    const handleIconClick = (id) => {
        //dispatch(setCurFirstCateId(id));
        //history.push('/ct/'+id)
    }

    return (
        <HpCateItemsBlock>
            <HpCateItemsUlBlock>
                {
                    categoryItems.map((cateItem, idx) => {
                        return (
                            <Link to={"/ct/"+cateItem.id} key={idx}>
                                <CateIconBtn
                                    img={cateItem.cate_img}
                                    text={cateItem.cate_name}
                                    onClick={() => handleIconClick(cateItem.id)}
                                    isSelected={false}
                                    isForceTitle={true} />
                            </Link>
                        )
                    })
                }
            </HpCateItemsUlBlock>
        </HpCateItemsBlock>
    )

};

export default HpCateItems;
